// src/components/pages/Pessoa/tabs/PessoaTabCabecalho.jsx

import { Box, Typography } from '@mui/material';
import moment from 'moment';

import PessoaImagemField from './PessoaImagemField';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';
import SelectEmpresa from '../../../form/SelectEmpresa';

import { retornaDataHora } from '../../../../utils/retornaDataFormatada';
import maskCPForCNPJ from '../../../../utils/maskCPForCNPJ';

export default function PessoaTabCabecalho({ module, profile, imagemModule, EnumTipo, EnumVinculoFinanceiro, optionsEmpresa }) {
    const { dados, handlePessoaChange, handlePessoaBlur } = module;
    const show = profile.show.cabecalho;
    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">Informações da pessoa</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <PessoaImagemField dados={dados} module={imagemModule} />
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <SelectEmpresa
                    name="empresaId"
                    text="Empresa"
                    options={optionsEmpresa}
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.empresaId}
                    isEnum={false}
                    notOptNull={true}
                />

                <Input
                    text="Data Cadastro"
                    type="datetime-local"
                    name="createdAt"
                    placeholder="última atualização"
                    title="Data de inserção do cadastro no sistema"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={(dados.createdAt && retornaDataHora(dados.createdAt)) || retornaDataHora(moment())}
                    readonly={true}
                />

                <Input
                    text="Data Atualização"
                    type="datetime-local"
                    name="updatedAt"
                    placeholder="última atualização"
                    title="Data da última atualização dos dados"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={(dados.updatedAt && retornaDataHora(dados.updatedAt)) || retornaDataHora(moment())}
                    readonly={true}
                />
                {show.colaborador && (
                    <>
                        <Checkbox
                            title="Colaborador/Funcionário da empresa, quando esta opção está marcada indica que é um colaborador da empresa, o mesmo deve ter acesso a processos dentro da empresa"
                            text="Colaborador"
                            name="funcionario"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.funcionario}
                            checked={!!dados.funcionario}
                        />
                    </>
                )}

                <Checkbox
                    title="Usuário da empresa, indica que a pessoa tem acesso ao sistema"
                    text="Usuário"
                    name="usuario"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.usuario}
                    checked={!!dados.usuario}
                />
                <Checkbox
                    title="Representante comercial de vendas"
                    text="Representante"
                    name="representante"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.representante}
                    checked={!!dados.representante}
                />
                <Checkbox
                    title="Pessoas com vinculos comerciais semelhantes a uma filial, em determinados modulos é necessário identificar a pessoa como parceiro comercial, quando esta opção está marcada indica que é um parceiro da empresa, e facilitará para separar dos demais clientes/fornecedores"
                    text="Parceiro"
                    name="parceiro"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.parceiro}
                    checked={!!dados.parceiro}
                />
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="CPF ou CNPJ"
                    type="text"
                    name="CPForCNPJ"
                    placeholder="CPF ou CNPJ da Pessoa"
                    title="Digite o CPF ou CNPJ da pessoa"
                    minlength={14}
                    maxlength={18}
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.CPForCNPJ ? maskCPForCNPJ(dados.CPForCNPJ) : ''}
                    required
                    readonly={false}
                />

                <Input
                    text="RG ou IE"
                    type="text"
                    name="RGorIE"
                    placeholder="RG ou IE da Pessoa"
                    title="Digite o Registro Geral ou Inscrição Estadual da pessoa"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.RGorIE ?? ''}
                    required={false}
                    readonly={false}
                />

                <Select
                    name="tipo"
                    text="Pessoa"
                    title="Identifica se a pessoa é física ou jurídica"
                    options={EnumTipo}
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.tipo || 'Jurídica'}
                    isEnum={true}
                />
                {show.inscricaoEstadualST && (
                    <>
                        <Input
                            text="IE ST"
                            type="text"
                            name="inscricaoEstadualST"
                            placeholder="IE ST"
                            title="Inscrição Estadual do Substituto Tributário"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.inscricaoEstadualST ?? ''}
                            required={false}
                            readonly={false}
                        />
                    </>
                )}

                {show.simplesNacional && (
                    <>
                        <Checkbox
                            title="Empresa cadastrada no Simples Nacional"
                            text="Simples Nacional"
                            name="simplesNacional"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.simplesNacional}
                            checked={!!dados.simplesNacional}
                        />
                    </>
                )}

                <Checkbox
                    title="Ativa ou Inativa a pessoa"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Nome Principal"
                    type="text"
                    name="nomePrincipal"
                    placeholder="Nome"
                    title="Nome atual da pessoa"
                    inputWidth="350px"
                    handleOnChange={handlePessoaChange}
                    handleOnBlur={handlePessoaBlur}
                    value={dados.nomePrincipal || ''}
                    readonly={false}
                />
                {show.vinculoFinanceiro && (
                    <>
                        <Select
                            name="vinculoFinanceiro"
                            text="Tipo"
                            title="Determina o vínculo financeiro com a empresa"
                            options={EnumVinculoFinanceiro}
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.vinculoFinanceiro || 'Ambos'}
                            isEnum={true}
                        />
                    </>
                )}

                {show.fabricante && (
                    <>
                        <Checkbox
                            title="Quando marcado torna a pessoa fabricante"
                            text="Fabricante"
                            name="fabricante"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.fabricante}
                            checked={!!dados.fabricante}
                        />
                    </>
                )}

                {show.pixDefinido && (
                    <>
                        <Checkbox
                            title="Quando marcado torna CPF ou o CNPJ pix padrão, o mesmo será incluido aos movimentos quando selecionado pix"
                            text="Pix CPF/CNPJ"
                            name="pixDefinido"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.pixDefinido}
                            checked={!!dados.pixDefinido}
                        />
                    </>
                )}

                {show.pixPadrao && (
                    <>
                        <Input
                            text="PIX padrão"
                            type="text"
                            name="pixPadrao"
                            placeholder="PIX padrão"
                            inputWidth="200px"
                            title="Digite a chave pix padrão para a pessoa, no modulo de lançamentos será incluido direto na chave PIX"
                            handleOnChange={handlePessoaChange}
                            handleOnBlur={handlePessoaBlur}
                            value={dados.pixPadrao ?? ''}
                            required={false}
                            readonly={false}
                        />
                    </>
                )}
            </Box>
        </Box>
    );
}
